export default function mapCategoriesToProducts(categories) {
  return categories.reduce((acc, curr) => {
    const split = curr.split('|');
    const key = split[0];
    const val = split[1];
    if (key) {
      if (!acc.find((i) => i.label === key)) {
        acc.push({ label: key, value: [Number(val)] });
      } else {
        const i = acc.findIndex((el) => el.label === key);
        acc[i].value.push(Number(val));
      }
    }
    return acc;
  }, []);
}
